import { lazy, Suspense, forwardRef } from 'react';

const LazyAgGrid = lazy(
  () =>
    import(
      /* webpackChunkName: "ag-grid" */
      /* webpackPrefetch: true */
      './AgGrid'
    ),
);

export default forwardRef(function AsyncAgGrid(props, ref) {
  return (
    <Suspense fallback={null}>
      <LazyAgGrid {...props} ref={ref} />
    </Suspense>
  );
});
